import { render, staticRenderFns } from "./TradeContractHome.vue?vue&type=template&id=2d63c441&scoped=true&"
import script from "./TradeContractHome.vue?vue&type=script&lang=js&"
export * from "./TradeContractHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63c441",
  null
  
)

export default component.exports